import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';

import {
  oAuthProviderStrategiesQuery,
  OAuthStrategiesResponse,
  OAuthStrategy,
} from 'apis/partnerIntegrations';

type UseReadOAuthStrategiesResponse = {
  strategies: readonly OAuthStrategy[];
  isStrategiesLoading: boolean;
  isStrategiesError: boolean;
};

/** A hook to retrieve OAuth strategies. */
export const useReadOAuthStrategies = (): UseReadOAuthStrategiesResponse => {
  const [strategies, setStrategies] = useState<readonly OAuthStrategy[]>([]);

  const {
    data: strategiesData,
    loading: isStrategiesLoading,
    error: strategiesError,
  } = useQuery<OAuthStrategiesResponse>(oAuthProviderStrategiesQuery);

  useEffect(() => {
    if (!isStrategiesLoading && strategiesData?.Management) {
      setStrategies(strategiesData.Management.oAuthProviderStrategies);
    }
  }, [strategiesData, isStrategiesLoading]);

  return {
    strategies,
    isStrategiesLoading,
    isStrategiesError: !!strategiesError,
  };
};
